export default __webpack_public_path__ + "static/media/quiz_bg.d2bdb50e.png";